<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
  lookup: Object
});
</script>
<template>
  <table class="w-full table-fixed">
    <thead>
      <tr>
        <th class="pb-3 text-left md:w-2/12" scope="col">
          {{ $t('lookup.partials.dns.card_detail_ns.rdtype') }}
        </th>
        <th class="pb-3 text-left md:w-1/12" scope="col">TTL</th>
        <th class="pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_ns.nameserver') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(nameserver, i) in lookup.nameservers" :key="i">
        <td>NS</td>
        <td>{{ lookup.ttl }}</td>
        <td>
          <Link
            :href="route('lookup.show', ['dns', nameserver])"
            class="text-primary-600"
          >
            {{ nameserver }}
          </Link>
        </td>
      </tr>
    </tbody>
  </table>
</template>
